import { Link } from 'react-router-dom'
import { useState } from 'react'
import { asset } from '../data/content'
import { useNewsletterSignup } from '../lib/newsletter'

type Props = {
  kicker?: string
  title: string
  subtitle: string
  dek: string
  image: string
}

export default function NewsletterSignup({ kicker, title, subtitle, dek, image }: Props) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const { done, sending, error, onSubmit } = useNewsletterSignup()

  return (
    <section className="grid grid-cols-1 gap-[clamp(24px,4vw,56px)] lg:grid-cols-2 lg:items-center">
      <div data-reveal className="relative min-h-[320px] overflow-hidden bg-sand aspect-[4/5] lg:min-h-[480px] lg:aspect-auto">
        <img
          src={asset(image)}
          alt="Sky Haarsma"
          className="block h-full w-full object-cover object-top"
        />
      </div>

      <div data-reveal className="flex max-w-[38ch] flex-col gap-5 lg:max-w-[42ch]">
        {kicker ? <p className="text-caps m-0 text-rose">{kicker}</p> : null}
        <h1 className="text-caps-hero m-0 text-balance text-ink">{title}</h1>
        <h2 className="text-caps-h3 m-0 text-ink">{subtitle}</h2>
        <p className="m-0 leading-relaxed text-copy">{dek}</p>

        {done ? (
          <p className="text-caps-h3 m-0 text-rose">You&apos;re in. Friday is going to be fun.</p>
        ) : (
          <form onSubmit={(event) => void onSubmit(event)} className="mt-2 flex max-w-md flex-col gap-4">
            <label className="sr-only" aria-hidden="true">
              Website
              <input name="website" tabIndex={-1} autoComplete="off" />
            </label>
            <label className="block">
              <span className="text-caps mb-2 block text-muted">Name</span>
              <input
                type="text"
                name="name"
                required
                autoComplete="name"
                value={name}
                onChange={(event) => setName(event.target.value)}
                className="h-12 w-full border border-rule bg-sand px-4 text-sm outline-none focus:border-rose"
              />
            </label>
            <label className="block">
              <span className="text-caps mb-2 block text-muted">Email</span>
              <input
                type="email"
                name="email"
                required
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="h-12 w-full border border-rule bg-sand px-4 text-sm outline-none focus:border-rose"
              />
            </label>
            <button
              type="submit"
              disabled={sending}
              className="text-caps h-12 self-start bg-ink px-8 text-white hover:bg-rose disabled:opacity-60"
            >
              {sending ? 'Subscribing…' : 'Subscribe'}
            </button>
            {error ? (
              <p role="alert" className="m-0 text-sm text-rose">
                {error}
              </p>
            ) : null}
          </form>
        )}

        <span className="max-w-[46ch] text-[11px] leading-normal text-muted">
          By subscribing you agree to receive emails from TIGG and accept our{' '}
          <Link to="/terms/" className="underline underline-offset-2 hover:text-rose">
            terms of use
          </Link>{' '}
          and{' '}
          <Link to="/privacy/" className="underline underline-offset-2 hover:text-rose">
            privacy policy
          </Link>
          .
        </span>
      </div>
    </section>
  )
}
